(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card-gallery"] && !Shopify.designMode) return;
  try {
    // "Připravujeme" chips carry their launch timestamp; at that moment they
  // quietly leave, even on a page that was rendered before the launch.
  if (!window.__evBadgeExpiry) {
    window.__evBadgeExpiry = true;
    var evExpireTick = function () {
      var now = Date.now();
      document.querySelectorAll('.ev-badge[data-ev-expires]').forEach(function (b) {
        var at = (parseInt(b.dataset.evExpires, 10) || 0) * 1000;
        if (at && now >= at) {
          var wrap = b.closest('.ev-badges');
          b.remove();
          if (wrap && !wrap.querySelector('.ev-badge, .product-badges__badge')) wrap.remove();
        }
      });
    };
    evExpireTick();
    setInterval(evExpireTick, 1000);
    document.addEventListener('visibilitychange', evExpireTick);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["coffee-origin"] && !Shopify.designMode) return;
  try {
    // Farmer panel + pill interactions, one delegated layer for every card
  // surface (homepage grid, collection, search, PDP featured carousel).
  //
  //  desktop (hover+fine pointer, >=990px):
  //    pill hover  -> panel opens after a short beat
  //    pill click  -> product page (card link)
  //    avatar click-> portrait lightbox
  //  touch:
  //    pill tap    -> panel toggles; next tap anywhere dismisses
  //    card tap    -> product page (unchanged)
  //
  // The panel is PORTALED to <body> and positioned fixed from the pill's
  // rect: carousel tracks and the card hover-lift transform can neither
  // clip nor drag it. After the lift animation settles we re-measure once
  // so the panel sits exactly where the pill ended up.
  if (!window.__evFarmerPanel) {
    window.__evFarmerPanel = true;
    var evDesktop = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');
    var evActive = null; // { pill, pop, home }
    var evHoverTimer = null;
    var evSettleTimer = null;

    function evPanelFor(pill) {
      if (evActive && evActive.pill === pill) return evActive.pop;
      var tag = pill.closest('.coffee-origin-tag');
      return tag ? tag.querySelector('.ev-farmer-pop') : null;
    }

    function evPlace(pop, pill) {
      var r = pill.getBoundingClientRect();
      var pw = pop.offsetWidth || 300;
      var ph = pop.offsetHeight || 420;
      var cx = r.left + r.width / 2;
      var left = Math.min(Math.max(cx, pw / 2 + 8), window.innerWidth - pw / 2 - 8);
      var top = r.top - ph - 14;
      if (top < 8) top = Math.min(r.bottom + 14, window.innerHeight - ph - 8);
      if (top < 8) top = 8;
      pop.style.left = left + 'px';
      pop.style.top = top + 'px';
    }

    function evClose() {
      clearTimeout(evHoverTimer);
      clearTimeout(evSettleTimer);
      if (!evActive) return;
      var a = evActive;
      evActive = null;
      a.pop.classList.remove('is-open');
      setTimeout(function () {
        if (!evActive || evActive.pop !== a.pop) {
          a.pop.classList.remove('ev-farmer-pop--fixed');
          a.pop.style.left = '';
          a.pop.style.top = '';
          if (a.home && a.pop.parentNode === document.body) a.home.appendChild(a.pop);
        }
      }, 280);
    }

    function evOpen(pill) {
      if (evActive && evActive.pill === pill) return;
      var pop = evPanelFor(pill);
      if (!pop) return;
      evClose();
      var home = pop.parentNode;
      if (pop.parentNode !== document.body) document.body.appendChild(pop);
      pop.classList.add('ev-farmer-pop--fixed');
      evPlace(pop, pill);
      // commit the closed-state styles synchronously, then open: the entrance
      // still animates, and unlike requestAnimationFrame this cannot be
      // starved by frame throttling
      void pop.offsetHeight;
      pop.classList.add('is-open');
      evActive = { pill: pill, pop: pop, home: home };
      // the card hover-lift may still be moving the pill: settle once more
      evSettleTimer = setTimeout(function () {
        if (evActive && evActive.pill === pill) evPlace(pop, pill);
      }, 340);
    }

    // desktop hover in/out
    document.addEventListener('mouseover', function (e) {
      if (!evDesktop.matches) return;
      var pill = e.target.closest ? e.target.closest('.coffee-origin-tag__pill') : null;
      if (pill) {
        clearTimeout(evHoverTimer);
        evHoverTimer = setTimeout(function () { evOpen(pill); }, 30);
      } else if (evActive || evHoverTimer) {
        clearTimeout(evHoverTimer);
        evHoverTimer = null;
        evClose();
      }
    });

    // clicks: desktop pill -> product, touch pill -> toggle panel
    document.addEventListener('click', function (e) {
      var pill = e.target.closest ? e.target.closest('.coffee-origin-tag__pill') : null;
      if (!pill) return;
      if (evDesktop.matches) {
        if (e.target.closest('.coffee-origin-tag__avatar')) return;
        var card = pill.closest('.product-card, product-card');
        var link = card && card.querySelector('.product-card__link');
        if (link && link.href) window.location.href = link.href;
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      if (evActive && evActive.pill === pill) evClose();
      else evOpen(pill);
    });

    // touch dismiss: while open, the next tap outside closes and goes nowhere
    document.addEventListener('click', function (e) {
      if (evDesktop.matches || !evActive) return;
      var pillTap = e.target.closest ? e.target.closest('.coffee-origin-tag__pill') : null;
      if (pillTap) return; // pill handler decides (toggle or switch)
      e.preventDefault();
      e.stopPropagation();
      evClose();
    }, true);

    // a fixed panel must not float away from a scrolling page
    document.addEventListener('scroll', function () { if (evActive) evClose(); }, { passive: true, capture: true });
    window.addEventListener('resize', function () { if (evActive) evClose(); });
  }

  // Farmer avatar in the pill: desktop-only portrait lightbox (on touch the
  // panel owns the pill; the PDP featured carousel keeps plain navigation).
  if (!window.__evAvaBound) {
    window.__evAvaBound = true;
    document.addEventListener('click', function (e) {
      var img = e.target.closest ? e.target.closest('.coffee-origin-tag__avatar') : null;
      if (!img || !img.dataset.avaFull) return;
      if (img.closest('[id*="coffee_recommendations"]')) return;
      if (!window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)').matches) return;
      e.preventDefault();
      e.stopPropagation();
      var modal = document.createElement('figure');
      modal.className = 'ev-ava-modal';
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-label', img.dataset.avaName || '');
      var big = document.createElement('img');
      big.src = img.dataset.avaFull;
      big.alt = img.dataset.avaName || '';
      var cap = document.createElement('figcaption');
      cap.textContent = img.dataset.avaName || '';
      modal.appendChild(big);
      if (cap.textContent) modal.appendChild(cap);
      document.body.appendChild(modal);
      document.documentElement.style.overflow = 'hidden';
      requestAnimationFrame(function () { modal.classList.add('is-open'); });
      function close() {
        modal.classList.remove('is-open');
        document.documentElement.style.overflow = '';
        document.removeEventListener('keydown', onKey);
        setTimeout(function () { modal.remove(); }, 240);
      }
      function onKey(ev) { if (ev.key === 'Escape') close(); }
      modal.addEventListener('click', close);
      document.addEventListener('keydown', onKey);
    });
  }
  } catch(e) { console.error(e); }
})();

})();
